import React from 'react';
import { FadeIn } from './FadeIn';
import { X, Check } from 'lucide-react';
export function CerebroDigital() {
  const comparisons = [{
    task: 'Cliente pide escalar de $5K a $50K/mes',
    without: 'Improvisás el plan',
    with: 'Protocolo de escalado. 4 semanas.'
  }, {
    task: 'Necesitás diseñar un funnel completo',
    without: 'Armás campaña suelta',
    with: 'Funnel multi-etapa completo en 1 sesión'
  }, {
    task: 'Dirección pide propuesta profesional',
    without: 'Buscás plantillas en Google',
    with: 'Plantilla de propuesta de alto valor. Lista.'
  }, {
    task: 'Cliente tiene baja conversión post-clic',
    without: 'Cambiás el anuncio sin saber',
    with: 'Árbol de diagnóstico. Causa real en minutos.'
  }, {
    task: 'Querés cobrar más sin trabajar más horas',
    without: 'Bajás el precio para competir',
    with: 'Sistema de cobro Nivel 3. Fee + Performance.'
  }, {
    task: 'Querés conseguir clientes propios con Meta Ads',
    without: 'No tenés funnel propio',
    with: 'Funnel de captación para media buyers. Listo.'
  }];
  const includes = ['Los 3 Niveles del Media Buyer y cómo pasar del 2 al 3', 'La Economía del Nivel 3: más ingreso, menos horas, menos clientes', 'Framework de Auditoría de Negocio (17 preguntas para saber qué cliente tomar)', 'Arquitectura de 3 tipos de Funnel con esquemas copy/paste completos', 'Estrategia de Omnipresencia con presupuesto micro ($10-20/día)', 'Sistema de Broad Audiences para cuentas con píxel maduro', 'Distribución de presupuestos de $5K a $50K mensuales', 'Sistema de triggers para escalado controlado con metodología', 'Funnel de captación para conseguir tus propios clientes con Meta Ads', 'Modelos de cobro y contratos para proteger al estratega', 'Hoja de ruta de 90 días para implementar todo el sistema', '4 Assets listos: Auditoría + Propuesta + Funnels + Calculadora'];
  return <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-54">
      <FadeIn data-id="element-55">
        <h2 className="text-xl md:text-2xl font-bold text-center mb-8 flex items-center justify-center gap-2" data-id="element-56">
          <span className="text-2xl" data-id="element-57">🕊️</span> ¿QUÉ AGREGA EL MÁSTER ESTRATEGA
          LISTO?
        </h2>

        <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden mb-10" data-id="element-58">
          <div className="grid grid-cols-3 bg-gray-800/80 border-b border-gray-700 p-3 font-bold text-xs md:text-sm" data-id="element-59">
            <div className="text-gray-400" data-id="element-60">Situación en tu trabajo</div>
            <div className="text-red-400 text-center" data-id="element-61">❌ Sin el Máster</div>
            <div className="text-green-400 text-center" data-id="element-62">✅ Con el Máster</div>
          </div>

          <div className="divide-y divide-gray-800/50" data-id="element-63">
            {comparisons.map((item, index) => <div key={index} className="grid grid-cols-3 p-3 items-center text-xs md:text-sm hover:bg-gray-800/30 transition-colors" data-id="element-64">
                <div className="font-medium text-gray-300 pr-2" data-id="element-65">
                  {item.task}
                </div>
                <div className="text-center text-gray-400 flex flex-col items-center gap-1" data-id="element-66">
                  <span data-id="element-67">{item.without}</span>
                </div>
                <div className="text-center font-bold text-green-400 flex flex-col items-center gap-1 bg-green-900/10 py-2 rounded-lg px-1" data-id="element-68">
                  <span data-id="element-69">{item.with}</span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="bg-gray-900/50 border border-green-500/30 rounded-2xl p-6 md:p-8" data-id="element-70">
          <h3 className="text-xl font-bold text-green-400 mb-6 flex items-center gap-2" data-id="element-71">
            ✅ EL MÁSTER INCLUYE:
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-72">
            {includes.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300 text-sm" data-id="element-73">
                <span className="text-green-500 mt-0.5 shrink-0" data-id="element-74">✓</span> {item}
              </li>)}
          </ul>
        </div>
      </FadeIn>
    </section>;
}